import { render, staticRenderFns } from "./ProjectsDurationMetricModal.vue?vue&type=template&id=9220faa8&"
import script from "./ProjectsDurationMetricModal.vue?vue&type=script&lang=js&"
export * from "./ProjectsDurationMetricModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports